module.exports = __webpack_public_path__ + "img/question_bot.8908a4d7.svg";